import React from 'react';

const TickIcon = ({ color = '#757575', width = 20, height = 21, ...rest }) => {
  return (
    <svg {...rest} height={height} width={width} fill="none" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 10.3583L8.35833 12.7167L13.0833 8"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default TickIcon;
